import timezone from 'moment-timezone/moment-timezone';
import intl from 'react-intl-universal';

import { ContractType } from '@/config/constant';
import { IdataSource } from '@/utils';

/**
 * UTC+xx 转偏移量
 * UTC+8 UTC+08 UTC+08:00 -> 480
 * UTC-8 UTC-08 UTC-08:00 -> -480
 *  */
const parseCodeToOffset = (code) => {
  let offset = 0;
  if (code) {
    const [, symbol, hour, minute] = code.match(/UTC([+-])(\d+)?[:]?(\d+)?/) || ['+', 0, 0];
    let minutes = (hour || 0) * 60 + (minute || 0) * 1;
    if (Number.isNaN(minutes)) {
      minutes = 0;
    }
    offset = minutes;
    if (symbol === '-') {
      offset = -offset;
    }
  }
  return offset;
};

// moment-timezone-utils
const parseOffsetBase60 = (offset) => {
  const BASE60 = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWX';
  let output = '';
  const value = Math.abs(offset);
  let whole = Math.floor(value);
  while (whole > 0) {
    output = BASE60[whole % 60] + output;
    whole = Math.floor(whole / 60);
  }
  if (offset < 0) {
    return `-${output}`;
  }
  return output || '0';
};

// 设置时区
export const setCurrentTimeZone = (code, DST) => {
  const offset = parseCodeToOffset(code) + (DST ? 60 : 0);
  // name|attr|[offset]|[min, max]
  timezone.tz.add(`DNU|DO_NOT_USE|${parseOffsetBase60(-offset)}|00|-1jSoU5.H`);
  timezone.tz.setDefault('DNU');
};

export interface TenantSysConfig {
  certTypesDataSource: Array<IdataSource>;
  certTypesMap: object;
  allCertTypes: string;
  certTypes: Array<any>;
  allowLoginTypes: string;
  code: string;
  commonLanguage: string;
  contractType: string;
  currency: string;
  defaultCertType: number;
  defaultLanguage: string;
  juvenilesValidate: boolean;
  logo: string;
  name: string;
  nationValidate: boolean;
  regionCode: string;
  xzBalance: boolean;
  zoneId: string;
}

export interface TenantBaseConfig {
  CurrencySymbol: string;
  MobileAreaCode: string;
}

export interface TenantConfigValue {
  TenantBaseConfig: TenantBaseConfig;
  TenantSysConfig: Partial<TenantSysConfig>;
}

// 租户配置数据
export const TenantGlobalConfig = (() => {
  let contextValue: TenantConfigValue = {
    TenantBaseConfig: {
      CurrencySymbol: '',
      MobileAreaCode: null,
    },
    TenantSysConfig: {},
  };
  return {
    getSystemConfig: () => {
      return contextValue.TenantSysConfig;
    },
    getCurrencySymbol: () => {
      return contextValue.TenantBaseConfig.CurrencySymbol;
    },
    getConfigValue: () => contextValue,
    setConfigConfig: (value: Partial<TenantConfigValue>) => {
      contextValue = {
        ...contextValue,
        ...value,
      };
    },
  };
})();

// 配置的联系方式是否为空
export const requiredContractTypeIsEmpty: (val: any) => { isEmpty: boolean; msg: string } = (
  info,
) => {
  const emptyFnMap = {
    [ContractType.EMAIL]: () => ({
      isEmpty: !info?.email,
      msg: intl.get('reservation_error_guest_email_null'),
    }),
    [ContractType.MOBILE]: () => ({
      isEmpty: !info?.mobile,
      msg: intl.get('reservation_error_guest_mobile_null'),
    }),
    [ContractType.CERTIFICATE]: () => ({
      isEmpty: !info?.certType || !info?.certNo,
      msg: intl.get('reservation_error_guest_cert_null'),
    }),
  };
  return emptyFnMap[TenantGlobalConfig.getSystemConfig().contractType]();
};
